module.exports = __webpack_public_path__ + "static/file/Sample_Parent_Email_BlackWhite-2.6b3ffa0.docx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/Sample_Parent_Email_BlackWhite-2.docx
// module id = ZIbp
// module chunks = 18